<template>
	<div
		class="chat__contact flex items-center px-2 pt-4 pb-2"
		:class="{'bg-primary-gradient text-white shadow-lg': isActiveChatUser}"
	>
		<div class="contact__avatar mr-1">
			<vs-avatar class="border-2 border-solid border-white" :src="photoURL" size="42px" />
		</div>
		<div class="contact__container w-full flex items-center justify-between overflow-hidden">
			<div class="contact__info flex flex-col truncate w-5/6">
				<h5 class="g-tools--description" :class="{'text-white': isActiveChatUser}">
					{{ resource.name }}
				</h5>
				<span class="g-label--normal truncate">{{ resource.email }}</span>
			</div>
			<div class="chat__contact__meta flex self-start flex-col items-end w-1/6" v-if="total > 0">
				<span class="g-tools--description whitespace-no-wrap">{{ $t("New") }}</span>
				<vs-chip class="g-label--normal number" color="warning">{{ total }}</vs-chip>
			</div>
		</div>
	</div>
</template>

<script>
import {downloadFileFromFirebase} from "@/helpers/firebaseDB.js";
import moduleResource from "@/store/resource/moduleResource.js";
import User from "@/models/User.js";
import firebase from "firebase/app";

export default {
	props: {
		resource: {type: Object, required: true},
		isActiveChatUser: {type: Boolean},
		lastMessaged: {type: String, default: ""},
		showLastMsg: {type: Boolean, default: false},
		unseenMsg: {type: Number, default: 0},
		typeOfList: {type: String},
	},
	data() {
		return {
			database: firebase.database(),
			avatar: "",
			messages: [],
			total: 0,
			unseenTotal: 0,
			userSession: new User(),
		};
	},
	computed: {
		photoURL() {
			this.$emit("avatarUrlEmit", this.avatar);
			return this.avatar;
		},
		totalMessagesWithUnseen() {
			//this.$store.state.firebaseRealtime.messages.get(this.resource.id).length
			let data = this.$store.state.firebaseRealtime.firebaseTotalSeen[this.resource.id];
			return data !== undefined ? data : 0;
		},
	},
	methods: {
		getResourcePhoto() {
			const url = this.resource.img_url;
			if (!url) {
				return;
			}
			downloadFileFromFirebase(url)
				.then((res) => {
					this.avatar = res;
				})
				.catch((error) => {});
		},
		async getMessages() {
			const user = await this.userSession.getUser();
			const starCountRef = this.database.ref(`messages/${user.company_id}/${this.resource.id}`);
			try {
				starCountRef.on("value", (snapshot) => {
					const messages = [];
					snapshot.forEach((childSnapshot) => {
						// key will be "ada" the first time and "alan" the second time
						let key = childSnapshot.key;
						// childData will be the actual contents of the child
						let childData = {...childSnapshot.val(), id: key};
						messages.push(childData);
					});
					this.total = messages.filter((message) => !message.seen).length;
					// Actualizacion del total de mensajes de cada recurso presentado en pantalla
					this.unseenTotal = messages.filter((message) => message.state === "Pendiente por resolver").length;
					this.$store.commit("moduleResource/UPDATE_MESSAGE_RESOURCE", {
						resource: this.resource,
						total_messages: this.total,
					});
				});
			} catch (error) {}
		},
	},
	watch: {
		unseenTotal(val) {
			// Si al momento de actualizar el total es cero, removemos el recurso de la lista de recursos del listado de recientes
			if (val === 0 && this.typeOfList === "recent") {
				this.$store.commit("moduleResource/REMOVE_RESOURCE_COMMUNICATION", this.resource.id);
				this.$emit("cleanListMessages");
			}
		},
	},
	mounted() {
		this.getResourcePhoto();
		this.getMessages();
	},
	created() {
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}
	},
};
</script>
